export const styledSidebar = {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    width: '$sidebarWidth',
}

export const styledSidebarHeader = {padding: '$sidebarPadding'}

export const styledSidebarContent = {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    overflowY: 'auto',
    padding: '0 $sidebarPadding $sidebarPadding $sidebarPadding',
}

export const styledGroup = {
    '&:before': {
        color: '$sidebarLabelText',
        content: 'attr(aria-label)',
        display: 'block',
        fontSize: '0.7rem',
        marginBottom: '0.6rem',
        textTransform: 'uppercase',
    },
    '&:empty': {display: 'none'},
    '&:first-of-type': {
        marginTop: 0,
        paddingTop: 0,
    },
    '&:last-of-type': {
        borderBottom: 0,
        paddingBottom: 0,
    },
    'listStyleType': 'none',
    'margin': '1rem 0 0 0',
    'padding': 0,
    'variants': {
        nested: {
            true: {
                '&:before': {
                    content: '',
                    display: 'none',
                },
                'margin': 0,
            },
        },
    },
}

export const styledList = {
    variants: {
        nested: {
            true: {
                borderLeft: '1px solid $sidebarNestedBorder',
                borderRadius: 'unset',
                marginLeft: '1rem',
                paddingLeft: '0.4rem',
            },
        },
    },
}

export const styledContent = {
    '&&:hover': {'button[data-id="dropdown-caret"]': {visibility: 'visible'}},
    'button[data-id="dropdown-caret"]:not(:focus)': {visibility: 'hidden'},
    'display': 'flex',
}

export const styledButton = {
    '&:focus': {outline: 'none'},
    '&:focus-visible': {outline: '2px solid $buttonOutlineFocus'},
    '&:hover': {backgroundColor: '$sidebarButtonBackgroundHover'},
    'alignItems': 'center',
    'backgroundColor': '$sidebarButtonBackground',
    'border': 0,
    'borderRadius': '$sidebarButtonBorder',
    'display': 'flex',
    'flexGrow': 1,
    'overflowX': 'hidden',
    'padding': '$sidebarButtonPadding',
    'variants': {active: {true: {backgroundColor: '$sidebarButtonBackgroundActive'}}},
}

export const styledName = {
    '& > div': {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    'color': '$sidebarButtonText',
    'flexGrow': 1,
    'fontSize': '$sidebarButtonText',
    'marginLeft': '$sidebarButtonMargingHorizontal',
    'overflowX': 'hidden',
    'textAlign': 'left',
    'textOverflow': 'ellipsis',
    'variants': {
        status: {
            hidden: {},
            highlight: {
                color: '$highlight',
                fontWeight: 'bold',
            },
            unread: {fontWeight: 'bold'},
            visible: {},
        },
    },
    'whiteSpace': 'nowrap',
}

export const styledStatus = {
    '& + div': {marginLeft: '$sidebarStatusMarginHorizontal'},
    '& svg': {display: 'flex'},
    'color': '$sidebarStatusIcon',
    'display': 'flex',
    'marginLeft': '$sidebarStatusMarginHorizontal',
    'variants': {active: {true: {color: '$sidebarStatusIconActive'}}},
}
